export enum TenantRole {
    owner = "Owner",
    admin = "Admin",
    user = "User",
}